import React, { useEffect } from "react";
import { ArrowLeft } from "../../Public/assets/index";
import { CardFooter } from "../ui/card";
import Loader from "../Loader/PageLoader";
import DeleteModal from "../Model/Delete";
import { useOverview } from "./../../hooks";

// disable background body scroll
const usePreventScroll = () => {
  useEffect(() => {
    // Save initial body style
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // Prevent scrolling on mount
    document.body.style.overflow = "hidden";

    // Re-enable scrolling on unmount
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);
};

function DrawerContainer({
  children,
  stateVariable,
  closeSheet,
  title,
  footerContent,
  handleDecrement,
  currentFlow,
  isLoading,
  isLoadingTransfer,
}) {
  const { isDeleteModalOpen, handleConfirmDelete, handleCloseModal, deleting } =
    useOverview();

  const renderButton = () => {
    if (currentFlow === "beneficiaryAdded") {
      return " ";
    }
    if (stateVariable === 1) {
      if (currentFlow === "ChangeMethod" || currentFlow === "addNewPayee") {
        return (
          !isLoading && (
            <button
              onClick={handleDecrement}
              className="flex items-center rounded-sm ring-offset-background transition-opacity hover:opacity-100 focus:outline-none"
            >
              <img src={ArrowLeft} alt="ArrowLeft" />
            </button>
          )
        );
      }
      return (
        <button
          onClick={closeSheet}
          className="flex items-center rounded-sm ring-offset-background transition-opacity hover:opacity-100 focus:outline-none"
        >
          <img src={ArrowLeft} alt="ArrowLeft" />
        </button>
      );
    } else if (currentFlow === "WalletTransfer" && (stateVariable === 3 || stateVariable === 4)) {
      return " ";
    } else if (currentFlow === "SendMoney" && (stateVariable === 4 || stateVariable === 5)) {
      return " ";
    } else {
      return (
        !isLoadingTransfer && (
          <button
            onClick={handleDecrement}
            className="flex items-center rounded-sm ring-offset-background transition-opacity hover:opacity-100 focus:outline-none"
          >
            <img src={ArrowLeft} alt="ArrowLeft" />
          </button>
        )
      );
    }
  };

  usePreventScroll();
  return (
    <div className="fixed inset-0 z-[996]">
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={() => {
            !isLoading && closeSheet();
          }}
        ></div>

        <div className="flex absolute  bottom-0 sm:right-0 sm:top-0 max-w-full">
          <div className="w-screen sm:max-w-md ">
            <div className="h-full flex flex-col bg-white rounded-t-2xl sm:rounded-none shadow-xl overflow-y-scroll">
              <div className="flex gap-2 px-[28px] py-[24px] border-b items-center">
                {renderButton()}

                {/* Dynamic Title from props */}
                <h2 className="text-base font-geomanistBold text-blackShade">
                  {title}
                </h2>
              </div>

              {/* Children Content */}

              <div
                className={`relative px-4 overflow-scroll sm:px-6  h-full ${
                  footerContent !== null &&
                  !isLoading &&
                  (currentFlow === "beneficiaryAdded"
                    ? "max-h-[calc(100dvh-220px)] sm:min-h-[calc(100dvh-220px)]"
                    : "max-h-[calc(100dvh-185px)] sm:min-h-[calc(100dvh-145px)]")
                }`}
              >
                {isLoading && (
                  <div className="absolute inset-0 bg-white bg-opacity-80 z-10 flex items-center justify-center">
                    <div className=" h-20 w-20">
                      <Loader />
                    </div>
                  </div>
                )}
                {children}
              </div>

              {/* Dynamic Footer */}
              {footerContent && !isLoading && (
                <div className=" w-full border-t">
                  <CardFooter className="px-4 sm:px-6 py-4 w-full">
                    {footerContent}
                  </CardFooter>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        isDeleting={deleting}
      />
    </div>
  );
}

export default DrawerContainer;
